if (!customElements.get('ebarrito-related-slider')) {
  customElements.define('ebarrito-related-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-related-track]');
      this.previous = this.querySelector('[data-related-previous]');
      this.next = this.querySelector('[data-related-next]');
      this.counter = this.querySelector('[data-related-counter]');
      this.controls = this.querySelector('[data-related-controls]');
      if (!this.track || !this.previous || !this.next || !this.counter) return;
      this.initialized = true;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', this.refresh, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.querySelectorAll('.ebarrito-related-card__second').forEach((image) => {
        const ready = () => {
          if (image.naturalWidth) image.parentElement.setAttribute('data-secondary-ready', '');
        };
        if (image.complete) ready();
        image.addEventListener('load', ready, { once: true, signal });
      });
      this.observer = new ResizeObserver(this.refresh);
      this.observer.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.initialized = false;
    }

    metrics() {
      const cards = Array.from(this.track.children);
      const columns = Number(getComputedStyle(this.track).getPropertyValue('--related-columns')) || 2;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = (cards[0]?.getBoundingClientRect().width || 0) + gap;
      const first = step ? Math.round(Math.abs(this.track.scrollLeft) / step) : 0;
      return { cards, columns, step, first };
    }

    update() {
      if (!this.isConnected) return;
      const { cards, columns, first } = this.metrics();
      const last = Math.min(cards.length, first + columns);
      this.previous.disabled = first === 0;
      this.next.disabled = last >= cards.length;
      this.controls.hidden = cards.length <= columns;
      this.counter.textContent = this.dataset.range.replace('[first]', String(first + 1)).replace('[last]', String(last)).replace('[total]', String(cards.length));
    }

    move(direction) {
      const { cards, columns, step, first } = this.metrics();
      const index = Math.min(Math.max(0, first + direction * columns), Math.max(0, cards.length - columns));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: index * step * (rtl ? -1 : 1), behavior: reducedMotion ? 'instant' : 'smooth' });
    }
  });
}
